module.exports = __webpack_public_path__ + "static/media/ic_star_logo_card.7ba22548.svg";